var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxGood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 15L7.0335 14.1333C5.91127 13.1222 4.9835 12.25 4.25016 11.5167C3.51683 10.7833 2.9335 10.125 2.50016 9.54166C2.06683 8.95833 1.76405 8.42222 1.59183 7.93333C1.41961 7.44444 1.3335 6.94444 1.3335 6.43333C1.3335 5.38889 1.6835 4.51666 2.3835 3.81666C3.0835 3.11666 3.95572 2.76666 5.00016 2.76666C5.57794 2.76666 6.12794 2.88888 6.65016 3.13333C7.17239 3.37777 7.62239 3.72222 8.00016 4.16666C8.37794 3.72222 8.82794 3.37777 9.35016 3.13333C9.87239 2.88888 10.4224 2.76666 11.0002 2.76666C12.0446 2.76666 12.9168 3.11666 13.6168 3.81666C14.3168 4.51666 14.6668 5.38889 14.6668 6.43333C14.6668 6.94444 14.5807 7.44444 14.4085 7.93333C14.2363 8.42222 13.9335 8.95833 13.5002 9.54166C13.0668 10.125 12.4835 10.7833 11.7502 11.5167C11.0168 12.25 10.0891 13.1222 8.96683 14.1333L8.00016 15Z",
    fill: "#777E91"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxGood);
export default __webpack_public_path__ + "static/media/box_good.8dc9d559.svg";
export { ForwardRef as ReactComponent };